export const isPublicAudience = (page) => page?.props?.auth?.is_public === true;

export function localizedPublicUrl(value, locale = 'it', base = 'https://public.invalid') {
    if (!value) return null;
    try {
        const url = new URL(value, base);
        if (!['http:', 'https:'].includes(url.protocol)) return null;
        url.searchParams.set('lang', locale);
        return /^[a-z][a-z\d+.-]*:/i.test(value) ? url.href : `${url.pathname}${url.search}${url.hash}`;
    } catch {
        return null;
    }
}

export function publicRecordUrl(sheet, id, locale = 'it') {
    if (!sheet || id === null || id === undefined) return null;
    return localizedPublicUrl(`/schede/${encodeURIComponent(sheet)}/${encodeURIComponent(id)}`, locale);
}

export function safePublicUrl(value) {
    if (!value) return null;
    try {
        return ['http:', 'https:'].includes(new URL(value, 'https://public.invalid').protocol) ? value : null;
    } catch {
        return null;
    }
}

export function publicFieldText(value) {
    if (value === null || value === undefined) return '';
    if (Array.isArray(value)) return value.map(publicFieldText).filter(Boolean).join('\n');
    if (typeof value === 'object') return Object.values(value).map(publicFieldText).filter(Boolean).join(' · ');
    return String(value);
}

export function serializePublicJsonLd(value) {
    return JSON.stringify(value).replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026');
}

const copy = {
    it: { guest: 'continua come ospite', login: 'Accedi', search: 'Cerca nel catalogo', submit: 'Cerca', clear: 'Azzera ricerca', empty: 'Nessuna scheda disponibile.', results: 'Risultati', categories: 'Tipi di scheda', pagination: 'Paginazione', record: 'Apri scheda', fields: 'Informazioni', images: 'Immagini', links: 'Collegamenti', pdf: 'Scarica PDF', source: 'Il contenuto è disponibile nella lingua originale.', catalogue: 'Catalogo', map: 'Cartografia', timeline: 'Timeline degli scavi' },
    en: { guest: 'continue as guest', login: 'Sign in', search: 'Search the catalogue', submit: 'Search', clear: 'Clear search', empty: 'No records available.', results: 'Results', categories: 'Record types', pagination: 'Pagination', record: 'Open record', fields: 'Information', images: 'Images', links: 'Related records', pdf: 'Download PDF', source: 'This content is available in its original language.', catalogue: 'Catalogue', map: 'Map', timeline: 'Excavation timeline' },
    fr: { guest: 'continuer en tant qu’invité', login: 'Se connecter', search: 'Rechercher dans le catalogue', submit: 'Rechercher', clear: 'Effacer la recherche', empty: 'Aucune fiche disponible.', results: 'Résultats', categories: 'Types de fiche', pagination: 'Pagination', record: 'Ouvrir la fiche', fields: 'Informations', images: 'Images', links: 'Fiches associées', pdf: 'Télécharger le PDF', source: 'Ce contenu est disponible dans sa langue d’origine.', catalogue: 'Catalogue', map: 'Cartographie', timeline: 'Chronologie des fouilles' },
    de: { guest: 'als Gast fortfahren', login: 'Anmelden', search: 'Katalog durchsuchen', submit: 'Suchen', clear: 'Suche zurücksetzen', empty: 'Keine Datensätze verfügbar.', results: 'Ergebnisse', categories: 'Datensatztypen', pagination: 'Seitennavigation', record: 'Datensatz öffnen', fields: 'Informationen', images: 'Bilder', links: 'Verknüpfte Datensätze', pdf: 'PDF herunterladen', source: 'Dieser Inhalt ist in seiner Originalsprache verfügbar.', catalogue: 'Katalog', map: 'Karte', timeline: 'Zeitleiste der Ausgrabungen' },
};

export const publicCopy = (locale) => copy[String(locale ?? 'it').split('-')[0]] ?? copy.it;
